import { Component, Injector, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { JackBaseComponentModule,MaterialModule,PageKind, UiModeType, } from 'jk-service';
import { AdvComModule, jkSingleComponent } from "jk-advcom";
import { SysseService,  } from '../_service_sys';
import { SysseEditComponent, } from '../_edit_sys';


@Component({
  selector: 'app-sysai85',
  standalone: true,
  providers: [],
  imports: [
    MaterialModule,
    JackBaseComponentModule,
    AdvComModule,
    //Sysai85DetailComponent,
    //SysseEditComponent,
  ],
  templateUrl: './sysai85Pkg.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: [],
})
export class Sysai85PkgComponent extends jkSingleComponent implements OnInit {
  override _programId = 'sysai85';
  override masterSrv: SysseService = new SysseService();
  override get srv(): SysseService {
    return this.masterSrv;
  }
  constructor() {
    super();
    this.uiMode=  UiModeType.dialog;
    this.title = '定時工作建立';
    this.gridInitOpt = {programId:this.programId,sortField:'JOBID',sort: 'asc',defaultSort: null,pageKind: this.pageKind};
    this.qbeConfig.addField = '';
    this.qbeConfig.addWhere = '';
    this.masterEditPage = SysseEditComponent;


    // this.constructorInit();
  }

  override async constructorInit() {
    await super.constructorInit();
    this.masterSrv.cdr = this.cdr;
  };




}
